export enum CourtSystemEntityAuditLogView {
  AdminUserAuditLog,
  UserGroupAuditLog,
  BillingGroupAuditLog,
  CaseAuditLog,
  HearingAuditLog,
  CourthouseAuditLog,
  DeletionAuditLog,
  CourtroomAuditLog,
  JudgeAuditLog,
}
